// Helper function to get country name from country code
export const getCountryName = (code: string): string => {
  // Comprehensive country mapping matching the backend
  const countryMap: Record<string, string> = {
    'ae': 'United Arab Emirates',
    'are': 'United Arab Emirates',
    'ar': 'Argentina',
    'arg': 'Argentina',
    'at': 'Austria',
    'aut': 'Austria',
    'au': 'Australia',
    'aus': 'Australia',
    'bd': 'Bangladesh',
    'bgd': 'Bangladesh',
    'be': 'Belgium',
    'bel': 'Belgium',
    'br': 'Brazil',
    'bra': 'Brazil',
    'ca': 'Canada',
    'can': 'Canada',
    'ch': 'Switzerland',
    'che': 'Switzerland',
    'cl': 'Chile',
    'chl': 'Chile',
    'cn': 'China',
    'chn': 'China',
    'co': 'Colombia',
    'col': 'Colombia',
    'cz': 'Czech Republic',
    'cze': 'Czech Republic',
    'de': 'Germany',
    'deu': 'Germany',
    'ger': 'Germany',
    'dk': 'Denmark',
    'dnk': 'Denmark',
    'es': 'Spain',
    'esp': 'Spain',
    'fi': 'Finland',
    'fin': 'Finland',
    'fr': 'France',
    'fra': 'France',
    'gb': 'United Kingdom',
    'uk': 'United Kingdom',
    'gr': 'Greece',
    'grc': 'Greece',
    'hu': 'Hungary',
    'hun': 'Hungary',
    'id': 'Indonesia',
    'idn': 'Indonesia',
    'il': 'Israel',
    'isr': 'Israel',
    'in': 'India',
    'ind': 'India',
    'ir': 'Iran',
    'irn': 'Iran',
    'it': 'Italy',
    'ita': 'Italy',
    'jo': 'Jordan',
    'jor': 'Jordan',
    'jp': 'Japan',
    'jpn': 'Japan',
    'kr': 'South Korea',
    'kor': 'South Korea',
    'lb': 'Lebanon',
    'lbn': 'Lebanon',
    'lk': 'Sri Lanka',
    'lka': 'Sri Lanka',
    'mx': 'Mexico',
    'mex': 'Mexico',
    'my': 'Malaysia',
    'mys': 'Malaysia',
    'nl': 'Netherlands',
    'nld': 'Netherlands',
    'no': 'Norway',
    'nor': 'Norway',
    'np': 'Nepal',
    'npl': 'Nepal',
    'pe': 'Peru',
    'per': 'Peru',
    'ph': 'Philippines',
    'phl': 'Philippines',
    'pk': 'Pakistan',
    'pak': 'Pakistan',
    'pl': 'Poland',
    'pol': 'Poland',
    'pt': 'Portugal',
    'prt': 'Portugal',
    'ru': 'Russia',
    'rus': 'Russia',
    'sa': 'Saudi Arabia',
    'sau': 'Saudi Arabia',
    'se': 'Sweden',
    'swe': 'Sweden',
    'sg': 'Singapore',
    'sgp': 'Singapore',
    'th': 'Thailand',
    'tha': 'Thailand',
    'tr': 'Turkey',
    'tur': 'Turkey',
    'ua': 'Ukraine',
    'ukr': 'Ukraine',
    'us': 'United States',
    'usa': 'United States',
    'uy': 'Uruguay',
    'ury': 'Uruguay',
    'vn': 'Vietnam',
    'vnm': 'Vietnam',

    // African Countries
    'dz': 'Algeria',
    'dza': 'Algeria',
    'ao': 'Angola',
    'ago': 'Angola',
    'bj': 'Benin',
    'ben': 'Benin',
    'bw': 'Botswana',
    'bwa': 'Botswana',
    'bf': 'Burkina Faso',
    'bfa': 'Burkina Faso',
    'bi': 'Burundi',
    'bdi': 'Burundi',
    'cv': 'Cabo Verde',
    'cpv': 'Cabo Verde',
    'cm': 'Cameroon',
    'cmr': 'Cameroon',
    'cf': 'Central African Republic',
    'caf': 'Central African Republic',
    'td': 'Chad',
    'tcd': 'Chad',
    'km': 'Comoros',
    'com': 'Comoros',
    'cg': 'Congo, Republic of the',
    'cog': 'Congo, Republic of the',
    'cd': 'Congo, Democratic Republic of the',
    'cod': 'Congo, Democratic Republic of the',
    'ci': 'Cote d\'Ivoire',
    'civ': 'Cote d\'Ivoire',
    'dj': 'Djibouti',
    'dji': 'Djibouti',
    'eg': 'Egypt',
    'egy': 'Egypt',
    'gq': 'Equatorial Guinea',
    'gnq': 'Equatorial Guinea',
    'er': 'Eritrea',
    'eri': 'Eritrea',
    'sz': 'Eswatini',
    'swz': 'Eswatini',
    'et': 'Ethiopia',
    'eth': 'Ethiopia',
    'ga': 'Gabon',
    'gab': 'Gabon',
    'gm': 'Gambia',
    'gmb': 'Gambia',
    'gh': 'Ghana',
    'gha': 'Ghana',
    'gn': 'Guinea',
    'gin': 'Guinea',
    'gw': 'Guinea-Bissau',
    'gnb': 'Guinea-Bissau',
    'ke': 'Kenya',
    'ken': 'Kenya',
    'ls': 'Lesotho',
    'lso': 'Lesotho',
    'lr': 'Liberia',
    'lbr': 'Liberia',
    'ly': 'Libya',
    'lby': 'Libya',
    'mg': 'Madagascar',
    'mdg': 'Madagascar',
    'mw': 'Malawi',
    'mwi': 'Malawi',
    'ml': 'Mali',
    'mli': 'Mali',
    'mr': 'Mauritania',
    'mrt': 'Mauritania',
    'mu': 'Mauritius',
    'mus': 'Mauritius',
    'ma': 'Morocco',
    'mar': 'Morocco',
    'mz': 'Mozambique',
    'moz': 'Mozambique',
    'na': 'Namibia',
    'nam': 'Namibia',
    'ne': 'Niger',
    'ner': 'Niger',
    'ng': 'Nigeria',
    'nga': 'Nigeria',
    'rw': 'Rwanda',
    'rwa': 'Rwanda',
    'st': 'Sao Tome and Principe',
    'stp': 'Sao Tome and Principe',
    'sn': 'Senegal',
    'sen': 'Senegal',
    'sc': 'Seychelles',
    'syc': 'Seychelles',
    'sl': 'Sierra Leone',
    'sle': 'Sierra Leone',
    'so': 'Somalia',
    'som': 'Somalia',
    'za': 'South Africa',
    'zaf': 'South Africa',
    'ss': 'South Sudan',
    'ssd': 'South Sudan',
    'sd': 'Sudan',
    'sdn': 'Sudan',
    'tz': 'Tanzania',
    'tza': 'Tanzania',
    'tg': 'Togo',
    'tgo': 'Togo',
    'tn': 'Tunisia',
    'tun': 'Tunisia',
    'ug': 'Uganda',
    'uga': 'Uganda',
    'zm': 'Zambia',
    'zmb': 'Zambia',
    'zw': 'Zimbabwe',
    'zwe': 'Zimbabwe',
  };
  
  // If no code provided, return input as-is
  if (!code) return code;
  
  // First check if it's already a full country name
  const fullCountryNames = Object.values(countryMap);
  const isFullName = fullCountryNames.find(name => 
    name.toLowerCase() === code.toLowerCase()
  );
  if (isFullName) return isFullName;
  
  // Otherwise treat as code and lookup
  return countryMap[code.toLowerCase()] || code;
};

// List of available languages for mentor profiles and applications
export const availableLanguages = [
  'English',
  'Spanish',
  'French',
  'German',
  'Arabic',
  'Mandarin',
  'Hindi',
  'Portuguese',
  'Russian',
  'Japanese',
  'Korean',
  'Italian',
  'Dutch',
  'Turkish',
  'Polish',
  'Swedish',
  'Norwegian',
  'Danish',
  'Finnish',
  'Greek',
  'Hebrew',
  'Thai',
  'Vietnamese',
  'Indonesian',
  'Malay',
  'Tagalog',
  'Urdu',
  'Bengali',
  'Persian'
];

// Country code to flag URL mapping using flagcdn.com
export const COUNTRY_FLAG_MAP: Record<string, string> = {
  // Primary 2-letter codes with flag URLs
  'AE': 'https://flagcdn.com/w20/ae.png',
  'AR': 'https://flagcdn.com/w20/ar.png',
  'AT': 'https://flagcdn.com/w20/at.png',
  'AU': 'https://flagcdn.com/w20/au.png',
  'BD': 'https://flagcdn.com/w20/bd.png',
  'BE': 'https://flagcdn.com/w20/be.png',
  'BR': 'https://flagcdn.com/w20/br.png',
  'CA': 'https://flagcdn.com/w20/ca.png',
  'CH': 'https://flagcdn.com/w20/ch.png',
  'CL': 'https://flagcdn.com/w20/cl.png',
  'CN': 'https://flagcdn.com/w20/cn.png',
  'CO': 'https://flagcdn.com/w20/co.png',
  'CZ': 'https://flagcdn.com/w20/cz.png',
  'DE': 'https://flagcdn.com/w20/de.png',
  'DK': 'https://flagcdn.com/w20/dk.png',
  'ES': 'https://flagcdn.com/w20/es.png',
  'FI': 'https://flagcdn.com/w20/fi.png',
  'FR': 'https://flagcdn.com/w20/fr.png',
  'GB': 'https://flagcdn.com/w20/gb.png',
  'UK': 'https://flagcdn.com/w20/gb.png', // UK maps to GB flag
  'GR': 'https://flagcdn.com/w20/gr.png',
  'HU': 'https://flagcdn.com/w20/hu.png',
  'ID': 'https://flagcdn.com/w20/id.png',
  'IL': 'https://flagcdn.com/w20/il.png',
  'IN': 'https://flagcdn.com/w20/in.png',
  'IR': 'https://flagcdn.com/w20/ir.png',
  'IT': 'https://flagcdn.com/w20/it.png',
  'JO': 'https://flagcdn.com/w20/jo.png',
  'JP': 'https://flagcdn.com/w20/jp.png',
  'KR': 'https://flagcdn.com/w20/kr.png',
  'LB': 'https://flagcdn.com/w20/lb.png',
  'LK': 'https://flagcdn.com/w20/lk.png',
  'MX': 'https://flagcdn.com/w20/mx.png',
  'MY': 'https://flagcdn.com/w20/my.png',
  'NL': 'https://flagcdn.com/w20/nl.png',
  'NO': 'https://flagcdn.com/w20/no.png',
  'NP': 'https://flagcdn.com/w20/np.png',
  'PE': 'https://flagcdn.com/w20/pe.png',
  'PH': 'https://flagcdn.com/w20/ph.png',
  'PK': 'https://flagcdn.com/w20/pk.png',
  'PL': 'https://flagcdn.com/w20/pl.png',
  'PT': 'https://flagcdn.com/w20/pt.png',
  'RU': 'https://flagcdn.com/w20/ru.png',
  'SA': 'https://flagcdn.com/w20/sa.png',
  'SE': 'https://flagcdn.com/w20/se.png',
  'SG': 'https://flagcdn.com/w20/sg.png',
  'TH': 'https://flagcdn.com/w20/th.png',
  'TR': 'https://flagcdn.com/w20/tr.png',
  'UA': 'https://flagcdn.com/w20/ua.png',
  'US': 'https://flagcdn.com/w20/us.png',
  'USA': 'https://flagcdn.com/w20/us.png',
  'UY': 'https://flagcdn.com/w20/uy.png',
  'VN': 'https://flagcdn.com/w20/vn.png',

  // African Countries
  'DZ': 'https://flagcdn.com/w20/dz.png',
  'AO': 'https://flagcdn.com/w20/ao.png',
  'BJ': 'https://flagcdn.com/w20/bj.png',
  'BW': 'https://flagcdn.com/w20/bw.png',
  'BF': 'https://flagcdn.com/w20/bf.png',
  'BI': 'https://flagcdn.com/w20/bi.png',
  'CV': 'https://flagcdn.com/w20/cv.png',
  'CM': 'https://flagcdn.com/w20/cm.png',
  'CF': 'https://flagcdn.com/w20/cf.png',
  'TD': 'https://flagcdn.com/w20/td.png',
  'KM': 'https://flagcdn.com/w20/km.png',
  'CG': 'https://flagcdn.com/w20/cg.png',
  'CD': 'https://flagcdn.com/w20/cd.png',
  'CI': 'https://flagcdn.com/w20/ci.png',
  'DJ': 'https://flagcdn.com/w20/dj.png',
  'EG': 'https://flagcdn.com/w20/eg.png',
  'GQ': 'https://flagcdn.com/w20/gq.png',
  'ER': 'https://flagcdn.com/w20/er.png',
  'SZ': 'https://flagcdn.com/w20/sz.png',
  'ET': 'https://flagcdn.com/w20/et.png',
  'GA': 'https://flagcdn.com/w20/ga.png',
  'GM': 'https://flagcdn.com/w20/gm.png',
  'GH': 'https://flagcdn.com/w20/gh.png',
  'GN': 'https://flagcdn.com/w20/gn.png',
  'GW': 'https://flagcdn.com/w20/gw.png',
  'KE': 'https://flagcdn.com/w20/ke.png',
  'LS': 'https://flagcdn.com/w20/ls.png',
  'LR': 'https://flagcdn.com/w20/lr.png',
  'LY': 'https://flagcdn.com/w20/ly.png',
  'MG': 'https://flagcdn.com/w20/mg.png',
  'MW': 'https://flagcdn.com/w20/mw.png',
  'ML': 'https://flagcdn.com/w20/ml.png',
  'MR': 'https://flagcdn.com/w20/mr.png',
  'MU': 'https://flagcdn.com/w20/mu.png',
  'MA': 'https://flagcdn.com/w20/ma.png',
  'MZ': 'https://flagcdn.com/w20/mz.png',
  'NA': 'https://flagcdn.com/w20/na.png',
  'NE': 'https://flagcdn.com/w20/ne.png',
  'NG': 'https://flagcdn.com/w20/ng.png',
  'RW': 'https://flagcdn.com/w20/rw.png',
  'ST': 'https://flagcdn.com/w20/st.png',
  'SN': 'https://flagcdn.com/w20/sn.png',
  'SC': 'https://flagcdn.com/w20/sc.png',
  'SL': 'https://flagcdn.com/w20/sl.png',
  'SO': 'https://flagcdn.com/w20/so.png',
  'ZA': 'https://flagcdn.com/w20/za.png',
  'SS': 'https://flagcdn.com/w20/ss.png',
  'SD': 'https://flagcdn.com/w20/sd.png',
  'TZ': 'https://flagcdn.com/w20/tz.png',
  'TG': 'https://flagcdn.com/w20/tg.png',
  'TN': 'https://flagcdn.com/w20/tn.png',
  'UG': 'https://flagcdn.com/w20/ug.png',
  'ZM': 'https://flagcdn.com/w20/zm.png',
  'ZW': 'https://flagcdn.com/w20/zw.png',
};

// Language to country code mapping for getting flags
export const LANGUAGE_COUNTRY_MAP: Record<string, string> = {
  'English': 'GB', // Great Britain flag for English
  'Spanish': 'ES',
  'French': 'FR',
  'German': 'DE',
  'Italian': 'IT',
  'Portuguese': 'PT',
  'Russian': 'RU',
  'Chinese': 'CN',
  'Mandarin': 'CN',
  'Japanese': 'JP',
  'Korean': 'KR',
  'Arabic': 'SA', // Using Saudi Arabia flag for Arabic
  'Hindi': 'IN',
  'Bengali': 'BD',
  'Urdu': 'PK',
  'Turkish': 'TR',
  'Dutch': 'NL',
  'Swedish': 'SE',
  'Norwegian': 'NO',
  'Danish': 'DK',
  'Finnish': 'FI',
  'Greek': 'GR',
  'Hebrew': 'IL',
  'Thai': 'TH',
  'Vietnamese': 'VN',
  'Indonesian': 'ID',
  'Malay': 'MY',
  'Tagalog': 'PH',
  'Filipino': 'PH',
  'Swahili': 'KE', // Using Kenya flag for Swahili
  'Amharic': 'ET',
  'Yoruba': 'NG',
  'Hausa': 'NG',
  'Igbo': 'NG',
  'Zulu': 'ZA',
  'Afrikaans': 'ZA',
  'Persian': 'IR',
  'Farsi': 'IR',
  'Ukrainian': 'UA',
  'Polish': 'PL',
  'Czech': 'CZ',
  'Hungarian': 'HU',
  'Romanian': 'RO',
  'Bulgarian': 'BG',
  'Croatian': 'HR',
  'Serbian': 'RS',
  'Slovak': 'SK',
  'Slovenian': 'SI'
};

// Helper function to get country code from country name for form submissions
export const getCountryCode = (countryName: string): string => {
  if (!countryName) return '';
  
  // If it's already a code (2-3 characters), return it
  if (countryName.length <= 3) {
    return countryName.toUpperCase();
  }
  
  // Comprehensive reverse mapping from country names to 2-letter codes
  const reverseMap: Record<string, string> = {
    'United Arab Emirates': 'AE',
    'Argentina': 'AR',
    'Austria': 'AT',
    'Australia': 'AU',
    'Bangladesh': 'BD',
    'Belgium': 'BE',
    'Brazil': 'BR',
    'Canada': 'CA',
    'Switzerland': 'CH',
    'Chile': 'CL',
    'China': 'CN',
    'Colombia': 'CO',
    'Czech Republic': 'CZ',
    'Germany': 'DE',
    'Denmark': 'DK',
    'Spain': 'ES',
    'Finland': 'FI',
    'France': 'FR',
    'United Kingdom': 'GB',
    'Greece': 'GR',
    'Hungary': 'HU',
    'Indonesia': 'ID',
    'Israel': 'IL',
    'India': 'IN',
    'Iran': 'IR',
    'Italy': 'IT',
    'Jordan': 'JO',
    'Japan': 'JP',
    'South Korea': 'KR',
    'Lebanon': 'LB',
    'Sri Lanka': 'LK',
    'Mexico': 'MX',
    'Malaysia': 'MY',
    'Netherlands': 'NL',
    'Norway': 'NO',
    'Nepal': 'NP',
    'Peru': 'PE',
    'Philippines': 'PH',
    'Pakistan': 'PK',
    'Poland': 'PL',
    'Portugal': 'PT',
    'Russia': 'RU',
    'Saudi Arabia': 'SA',
    'Sweden': 'SE',
    'Singapore': 'SG',
    'Thailand': 'TH',
    'Turkey': 'TR',
    'Ukraine': 'UA',
    'United States': 'US',
    'Uruguay': 'UY',
    'Vietnam': 'VN',

    // African Countries
    'Algeria': 'DZ',
    'Angola': 'AO',
    'Benin': 'BJ',
    'Botswana': 'BW',
    'Burkina Faso': 'BF',
    'Burundi': 'BI',
    'Cabo Verde': 'CV',
    'Cameroon': 'CM',
    'Central African Republic': 'CF',
    'Chad': 'TD',
    'Comoros': 'KM',
    'Congo, Republic of the': 'CG',
    'Congo, Democratic Republic of the': 'CD',
    'Cote d\'Ivoire': 'CI',
    'Djibouti': 'DJ',
    'Egypt': 'EG',
    'Equatorial Guinea': 'GQ',
    'Eritrea': 'ER',
    'Eswatini': 'SZ',
    'Ethiopia': 'ET',
    'Gabon': 'GA',
    'Gambia': 'GM',
    'Ghana': 'GH',
    'Guinea': 'GN',
    'Guinea-Bissau': 'GW',
    'Kenya': 'KE',
    'Lesotho': 'LS',
    'Liberia': 'LR',
    'Libya': 'LY',
    'Madagascar': 'MG',
    'Malawi': 'MW',
    'Mali': 'ML',
    'Mauritania': 'MR',
    'Mauritius': 'MU',
    'Morocco': 'MA',
    'Mozambique': 'MZ',
    'Namibia': 'NA',
    'Niger': 'NE',
    'Nigeria': 'NG',
    'Rwanda': 'RW',
    'Sao Tome and Principe': 'ST',
    'Senegal': 'SN',
    'Seychelles': 'SC',
    'Sierra Leone': 'SL',
    'Somalia': 'SO',
    'South Africa': 'ZA',
    'South Sudan': 'SS',
    'Sudan': 'SD',
    'Tanzania': 'TZ',
    'Togo': 'TG',
    'Tunisia': 'TN',
    'Uganda': 'UG',
    'Zambia': 'ZM',
    'Zimbabwe': 'ZW',
  };
  
  return reverseMap[countryName] || countryName;
};

// Get flag URL from country code
export const getCountryFlag = (countryCode: string): string | null => {
  if (!countryCode) return null;
  
  const upperCode = countryCode.toUpperCase();
  return COUNTRY_FLAG_MAP[upperCode] || null;
};

// Get flag URL from country name
export const getCountryFlagByName = (countryName: string): string | null => {
  const countryCode = getCountryCode(countryName);
  return countryCode ? getCountryFlag(countryCode) : null;
};

// Get flag URL for a language
export const getLanguageFlag = (language: string): string | null => {
  const countryCode = LANGUAGE_COUNTRY_MAP[language];
  return countryCode ? getCountryFlag(countryCode) : null;
};

// List of countries for dropdowns
export const COUNTRIES = Object.keys(
  {
    'United Arab Emirates': 'AE',
    'Argentina': 'AR',
    'Austria': 'AT',
    'Australia': 'AU',
    'Bangladesh': 'BD',
    'Belgium': 'BE',
    'Brazil': 'BR',
    'Canada': 'CA',
    'Switzerland': 'CH',
    'Chile': 'CL',
    'China': 'CN',
    'Colombia': 'CO',
    'Czech Republic': 'CZ',
    'Germany': 'DE',
    'Denmark': 'DK',
    'Spain': 'ES',
    'Finland': 'FI',
    'France': 'FR',
    'United Kingdom': 'GB',
    'Greece': 'GR',
    'Hungary': 'HU',
    'Indonesia': 'ID',
    'Israel': 'IL',
    'India': 'IN',
    'Iran': 'IR',
    'Italy': 'IT',
    'Jordan': 'JO',
    'Japan': 'JP',
    'South Korea': 'KR',
    'Lebanon': 'LB',
    'Sri Lanka': 'LK',
    'Mexico': 'MX',
    'Malaysia': 'MY',
    'Netherlands': 'NL',
    'Norway': 'NO',
    'Nepal': 'NP',
    'Peru': 'PE',
    'Philippines': 'PH',
    'Pakistan': 'PK',
    'Poland': 'PL',
    'Portugal': 'PT',
    'Russia': 'RU',
    'Saudi Arabia': 'SA',
    'Sweden': 'SE',
    'Singapore': 'SG',
    'Thailand': 'TH',
    'Turkey': 'TR',
    'Ukraine': 'UA',
    'United States': 'US',
    'Uruguay': 'UY',
    'Vietnam': 'VN',
    'Algeria': 'DZ',
    'Angola': 'AO',
    'Benin': 'BJ',
    'Botswana': 'BW',
    'Burkina Faso': 'BF',
    'Burundi': 'BI',
    'Cabo Verde': 'CV',
    'Cameroon': 'CM',
    'Central African Republic': 'CF',
    'Chad': 'TD',
    'Comoros': 'KM',
    'Congo, Republic of the': 'CG',
    'Congo, Democratic Republic of the': 'CD',
    'Cote d\'Ivoire': 'CI',
    'Djibouti': 'DJ',
    'Egypt': 'EG',
    'Equatorial Guinea': 'GQ',
    'Eritrea': 'ER',
    'Eswatini': 'SZ',
    'Ethiopia': 'ET',
    'Gabon': 'GA',
    'Gambia': 'GM',
    'Ghana': 'GH',
    'Guinea': 'GN',
    'Guinea-Bissau': 'GW',
    'Kenya': 'KE',
    'Lesotho': 'LS',
    'Liberia': 'LR',
    'Libya': 'LY',
    'Madagascar': 'MG',
    'Malawi': 'MW',
    'Mali': 'ML',
    'Mauritania': 'MR',
    'Mauritius': 'MU',
    'Morocco': 'MA',
    'Mozambique': 'MZ',
    'Namibia': 'NA',
    'Niger': 'NE',
    'Nigeria': 'NG',
    'Rwanda': 'RW',
    'Sao Tome and Principe': 'ST',
    'Senegal': 'SN',
    'Seychelles': 'SC',
    'Sierra Leone': 'SL',
    'Somalia': 'SO',
    'South Africa': 'ZA',
    'South Sudan': 'SS',
    'Sudan': 'SD',
    'Tanzania': 'TZ',
    'Togo': 'TG',
    'Tunisia': 'TN',
    'Uganda': 'UG',
    'Zambia': 'ZM',
    'Zimbabwe': 'ZW',
  }
).sort(); 